import React, { useEffect, useState } from 'react';
import endpoints from '../../../../config/endpoints';
import { postDataJSON } from '../../../../services/CommonApiService';
import BadgesComponent from '@components/common/Badges';
import Spinner from '@components/common/Spinner';
import './MCPCardDetails.css';
import { encodeWithKeyAndShift } from '../../../../utils/base64Utils';
import { errorLogger } from '@utils/applicationLogUtils';
import { COMMON_CONSTANTS } from '@constants/index';
import McpCard from '@components/common/McpCard';

const MCPCard = ({ beneficiaryDetails, benefType }: any) => {
  const [qrCodeData, setQrCodeData] = useState<any>();
  const [qrLoading, setQrLoading] = useState<boolean>(false);
  const id = beneficiaryDetails?.benef_id;
  const isChildBenef = benefType === COMMON_CONSTANTS.CHILD;
  const isBeneficiaryLogged = localStorage.getItem('isBeneficiaryLogged') || 'false';
  const isLoggedInBeneficiary = isBeneficiaryLogged === 'true';
  const gender = beneficiaryDetails?.gender_name;

  useEffect(() => {
    const fetchQrCodeData = async (mcp_qr_code_data: any) => {
      try {
        setQrLoading(true);
        const encoded_qr_code_data = encodeWithKeyAndShift(mcp_qr_code_data);
        const respose = await postDataJSON<any>(`${isLoggedInBeneficiary?endpoints.getBenefQrCode:endpoints.getQrCode}`, {
          mcp_qr_code_data: encoded_qr_code_data,
        });
        setQrLoading(false);
        setQrCodeData(respose.data);
      } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error);
      }
    };
    fetchQrCodeData(beneficiaryDetails?.mcp_qr_code_data);
  }, [id]);

  return (
    <>
      <div className="overview_user">
        <div className="show_scanner">
          <div className="show_scanner_details">
            {qrLoading ? (
              <Spinner />
            ) : (
              <img src={qrCodeData} alt="QR Code" height={130} />
            )}
          </div>
          <div className="show_header_btn_modal">
            <McpCard
              apiUrl={ 
                isChildBenef
                  ? isLoggedInBeneficiary ? endpoints.downloadChildBenefMcpCard : endpoints.downloadChildMcpCard
                  : isLoggedInBeneficiary ? endpoints.downloadBenefMcpCard : endpoints.downloadMcpCard
              }
              healthPassportApiUrl={
                isChildBenef 
                  ? null
                  :isLoggedInBeneficiary? endpoints.downloadBenefHealthPassport : endpoints.downloadHealthPassport
              }
              id={id}
              gender={gender}
            />
          </div>
        </div>
        <div className="qr_code_text">Scan to open Beneficiary's Profile</div>
        <BadgesComponent
          className="over-badge"
          badgeName="Beneficiary Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="overview-details">
          <div>
            <label className="overview-personal-details-label">
              {isChildBenef ? 'Mother Name' : 'Spouse Name'}
            </label>
            <div className="overview-personal-details-value">
              {isChildBenef
                ? beneficiaryDetails?.parent_name
                : beneficiaryDetails?.spouse_name}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">
              {isChildBenef ? "Mother's Mobile Number" : 'Mobile Number'}
            </label>
            <div className="overview-personal-details-value">
              {isChildBenef
                ? beneficiaryDetails?.parent_mob
                : beneficiaryDetails?.mob}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">
              Alternate Mobile Number
            </label>
            <div className="overview-personal-details-value">
              {beneficiaryDetails?.alternate_mob}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">
              Facility Type
            </label>
            <div className="overview-personal-details-value">
              {beneficiaryDetails?.facility_type?.join(',')}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">
              Facility Name
            </label>
            <div className="overview-personal-details-value">
              {beneficiaryDetails?.facility_name?.join(',')}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">
              Health Provider Name
            </label>
            <div className="overview-personal-details-value">
              {beneficiaryDetails?.health_provider_name?.join(',')}
            </div>
          </div>
          <div>
            <label className="overview-personal-details-label">Asha Name</label>
            <div className="overview-personal-details-value">
              {beneficiaryDetails?.mobiliser_f_name?.join(',')}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MCPCard;
